import { useAccessResource } from "./useAccessResource";
import { creatorVideoAccessService } from "../services/creatorVideoAccessService";

export const useCreatorVideoAccess = (username, userId) =>
  useAccessResource(username, userId, creatorVideoAccessService);
